import loadable from '@loadable/component'

// this test is here because we need in the immediate parent and want to lazy load shortstack content
export const isShortstack = (link: string) => {
    return link.indexOf('shortstack') >= 0
}

// Implementing lazy loaded components is explained in README.md
export const LazyShortStack = loadable(() => import('./Shortstack'))
